let prevSvg =  `
<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
  <path d="M16 7H3.83l5.59-5.59L8 0 0 8l8 8 1.41-1.41L3.83 9H16z" fill="#000"/>
</svg>
`;
let nextSvg =  `
<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" style="transform:scale(-1,1);">
  <path d="M16 7H3.83l5.59-5.59L8 0 0 8l8 8 1.41-1.41L3.83 9H16z" fill="#000"/>
</svg>
`;

let prevArrow = `<button type="button" class="slick-prev">${prevSvg}</button>`;
let nextArrow = `<button type="button" class="slick-next">${nextSvg}</button>`;


$('.blog-post-list-slick').slick({
    slidesToShow: 3,
    slidesToScroll: 3,
    autoplay: false,
    prevArrow:prevArrow,
    nextArrow: nextArrow,
    dots: true,
    Infinite: false,
    // autoplaySpeed: 2000,
    responsive: [
        {
          breakpoint: 1000,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2
          }
        },
        {
          breakpoint: 700,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
    ]
});

$('.prd_slider--slick').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: false,
    prevArrow:prevArrow,
    nextArrow: nextArrow,
    Infinite: false,
})

function validateDublinPhoneNumber(phoneNumber) {
  // const dublinPhoneNumberPattern = /^(?:\+353|0)1[ -]?\d{3}[ -]?\d{4}$/;
  // return dublinPhoneNumberPattern.test(phoneNumber);

  // Ensure only digits, spaces, '+', and '-' are allowed
  const onlyAllowedCharactersPattern = /^[\d+\- ]+$/;

  // Remove non-numeric characters (+, -, space) for length validation
  const strippedPhoneNumber = phoneNumber.replace(/[^\d]/g, '');

  // Ensure the phone number is within the correct range (min 10, max 13 numeric digits)
  const isValidLength = strippedPhoneNumber.length >= 7 && strippedPhoneNumber.length <= 15;

  // Return true if both conditions are met
  return onlyAllowedCharactersPattern.test(phoneNumber) && isValidLength;
}


// function checkout_number_required(btn){
  
//   let cart_num = document.querySelector('.cart_attr_number');

//   if(validateDublinPhoneNumber(cart_num.value) == '' || validateDublinPhoneNumber(cart_num.value) == null || validateDublinPhoneNumber(cart_num.value) == undefined ){
//     btn.setAttribute('disabled','')
//     btn.style.opacity = '0.6';
//     btn.style.cursor = 'not-allowed';
//     btn.classList.contains('checkout_hover_error') ? '' : btn.classList.add('checkout_hover_error');
//   }

//   cart_num.addEventListener('input', () => {
//     let isNumValid = false;
//     validateDublinPhoneNumber(cart_num.value) ? isNumValid = true : '';

//     if(isNumValid){
//       btn.removeAttribute('disabled','')
//       btn.style.opacity = '1';
//       btn.style.cursor = '';
//       btn.classList.contains('checkout_hover_error') ? btn.classList.remove('checkout_hover_error') : '';
//     }else{
//       btn.setAttribute('disabled','')
//       btn.style.opacity = '0.6';
//       btn.style.cursor = 'not-allowed';
//       btn.classList.contains('checkout_hover_error') ? '' : btn.classList.add('checkout_hover_error');
//     }

//   })

// }

function checkout_number_required(btn) {
  const cart_num = document.querySelector('.cart_attr_number');

  if (!cart_num || !btn) return;

  function updateButtonState() {
    const isNumValid = validateDublinPhoneNumber(cart_num.value.trim());

    if (isNumValid) {
      btn.removeAttribute('disabled');
      btn.style.opacity = '1';
      btn.style.cursor = '';
      btn.classList.remove('checkout_hover_error');
    } else {
      btn.setAttribute('disabled', '');
      btn.style.opacity = '0.6';
      btn.style.cursor = 'not-allowed';
      btn.classList.add('checkout_hover_error');
    }
  }

  updateButtonState();

  cart_num.addEventListener('input', updateButtonState);
  cart_num.addEventListener('change', updateButtonState);
}

function preventPhoneAutofillFromChangingCartQuantities() {
  const cartForm = document.querySelector('.cart-page');
  const phoneInput = cartForm?.querySelector('.cart_attr_number');
  if (!cartForm || !phoneInput) return;

  const quantityInputs = cartForm.querySelectorAll('input[data-line-key]');

  quantityInputs.forEach((input) => {
    input.addEventListener('focus', () => {
      input.setAttribute('data-last-valid-quantity', input.value);
    });
  });

  const restoreQuantitiesIfCorrupted = () => {
    quantityInputs.forEach((input) => {
      const lastValid = parseInt(input.getAttribute('data-last-valid-quantity') || input.defaultValue, 10) || 1;
      const current = parseInt(input.value, 10);
      const max = input.max ? parseInt(input.max, 10) : null;

      if (!Number.isFinite(current) || current < 1 || current > 999 || (max && current > max)) {
        input.value = lastValid;
      }
    });
  };

  phoneInput.addEventListener('input', restoreQuantitiesIfCorrupted);
  phoneInput.addEventListener('change', restoreQuantitiesIfCorrupted);
}

document.addEventListener('DOMContentLoaded', function () {
  const checkoutBtns = document.querySelectorAll(`button[type="submit"][name="checkout"]`);
  checkoutBtns.forEach(btn => checkout_number_required(btn));
  preventPhoneAutofillFromChangingCartQuantities();
});

// document.addEventListener("DOMContentLoaded", function() {
//   const buttons = document.querySelectorAll('.custom_blog_tab_button');
//   const containers = document.querySelectorAll('.custom_blog_container');
//   let checkout_btn = document.querySelectorAll(`button[type="submit"][name="checkout"]`);

//   buttons.forEach(button => {
//     button.addEventListener('click', function() {
//       const selectedCategory = this.textContent
//   .toLowerCase()
//   .replace(/\s*&\s*/g, ' ')   // remove & and extra spaces around it
//   .trim()
//   .replace(/\s+/g, '_'); 
      
//       console.log(selectedCategory)
//       handleTabClick(selectedCategory, this);
//     });
//   });

//   function handleTabClick(category, e) {
//     containers.forEach(container => { container.style.display = 'none' });
//     buttons.forEach(btn => btn.classList.remove('active'));

//     if (category === '') {
//       // containers.forEach(container => { container.style.display = 'block' });
//       containers[0].style.display = 'block';
//       buttons[0].classList.add('active');
//     }
//     else {
//       const activeContainer = document.querySelector(`.custom_blog_container.custom_tab_${category}`);
//       if (activeContainer) { 
//         activeContainer.style.display = 'block';
//         e.classList.add('active');
//       }
//     }
//   }

//   // console.log('Checkout', checkout_btn);
//   if(checkout_btn){ checkout_btn.forEach( i => checkout_number_required(i))}

// });